module.exports = __webpack_public_path__ + "static/media/address_image.137185a8.svg";